<div [formGroup]="form">
  <mat-form-field fxFlex>
    <input
      type="text"
      [id]="fieldname"
      [name]="fieldname"
      required
      #searchInput
      placeholder="Address Line 1"
      matInput
      [matAutocomplete]="auto"
      #trigger="matAutocompleteTrigger"
      formControlName="searchBox"
      [(ngModel)]="fieldvalue"
    />
    <mat-error *ngIf="!fieldvalue">is a required property</mat-error>
  </mat-form-field>

  <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
    <mat-option *ngIf="!isLoading && searchBox.value?.length < minSearchInputLength" disabled>
      <ng-container>
        <button mat-icon-button color="primary">
          Please enter at least {{ minSearchInputLength }} characters
        </button>
      </ng-container>
    </mat-option>
    <mat-option *ngIf="isLoading &&  addressOptions.length < 1 && searchBox.value?.length >= minSearchInputLength" disabled>
      <ng-container>
        <button mat-icon-button color="primary">
          No results found {{ filteredByZipCode ? "in zip code": "" }} {{ filteredByZipCode }}
        </button>
      </ng-container>
    </mat-option>
    <mat-option *ngFor="let address of addressOptions" [value]="address.streetLine">
      <ng-container *ngIf="address.entries <= 1">
        <button mat-icon-button color="primary" (click)="setAddress(address)">
          {{ address.streetLine }} {{ address.secondary }} , {{ address.city }} , {{ address.state }} , {{ address.zipcode }}
        </button>
      </ng-container>
      <ng-container *ngIf="address.entries > 1">
        <button mat-icon-button color="accent" (click)="fetchSubAddress(address)">
          {{ address.streetLine }} {{ address.secondary }} ({{ address.entries }} entries) {{ address.city }} , {{ address.state }}
          {{ address.zipcode }}
          <mat-icon>expand_more</mat-icon>
        </button>
      </ng-container>
    </mat-option>
  </mat-autocomplete>
</div>
